
import React, { useState, useContext } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { signIn } from '../firebase/signIn';

export const SignIn = () => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const emailChangeHandler = (event) => {
    setEmail(event.target.value);
  }

  const passwordChangeHandler = (event) => {
    setPassword(event.target.value);
  }

  const signInHandler = async (event) => {
    event.preventDefault();
    if (await signIn(email, password) === null) {
      setSnackbarOpen(true);
    }
  }

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const classes = useStyles();

  return (
    <>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        style={{ marginLeft: 0, marginTop: 25 }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="error"
        >
          Kunde inte logga in
        </Alert>
      </Snackbar>
      <div className={classes.formContainer}>
        <form
          noValidate
          autoComplete="off"
          onSubmit={signInHandler}
        >
          <TextField
            value={email}
            onChange={emailChangeHandler}
            id="email-input"
            label="Mejl"
            variant="outlined"
            className={classes.inputField}
          /><br />
          <TextField
            value={password}
            onChange={passwordChangeHandler}
            id="password-input"
            label="Lösenord"
            variant="outlined"
            className={classes.inputField}
            type="password"
          /><br />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            style={{ marginTop: 50, width: 200 }}
          // onClick={signInHandler}
          >
            Logga in
          </Button>
        </form>
      </div>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  formContainer: {
    marginTop: 125,
  },
  inputField: {
    marginTop: 25,
    marginBottom: 10,
    width: 300,
  },
}));